import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import logo from "../assets/Logga_GT_struktur_vit_bakgrund_2025c.png";
import "./css/UnderConstructionPage.css";
import img from "../assets/1._Boxen_bild_1.png";
import img2 from "../assets/2._Boxen_bild_2.png";
import img3 from "../assets/3._Boxen_bild_3.jpg";

function UnderConPage() {
    const [email, setEmail] = useState("");
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const imageArry = [img, img2, img3];

    const headings = [
        { line1: "Beredskap för", line2: "fred och frihet" },
        { line1: "Med omsorg", line2: "om morgondagen" },
        { line1: "Bara pepp -", line2: "inget prepp!" },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % headings.length);
                setFade(true);
            }, 1000);
        }, 7000);

        return () => clearInterval(interval);
    }, [headings.length]);

    const handleRegister = async () => {
        if (!email) return alert("Skriv in din e-postadress");

        const { error } = await supabase.from("nyhetsbrev").insert([{ email }]);

        if (error) {
            console.error(error);
            alert("Något gick fel!");
        } else {
            alert("Tack! Du är registrerad.");
            setEmail("");
        }
    };

    return (
        <div className="under-construction-container">
            <div className="images-row">
                <div className="left-image-column">
                    <img src={logo} alt="Under Construction" />

                    <p className={`quote-heading ${fade ? "" : "fade-out"}`}>
                        “<span className="line1">{headings[index].line1}</span>
                        <br />
                        <span className="line2">{headings[index].line2}</span>”
                    </p>

                    <p className="extra-text">
                        <Link to="/register" state={{ fromUnderConstruction: true }}>
                            {" "}
                            Registrera konto här
                        </Link>{" "}
                        redan nu för att kunna använda den kostnadsfria appen när den kommer
                        <br />
                        <a href="/Integritetspolicy_tillfällig_hemsida_andreas_nystrom_ab_v2.pdf" target="_blank" rel="noopener noreferrer" className="GDPR">
                            PDF GDPR good tomorrow
                        </a>
                    </p>
                    <div className="boxImage">
                        <img src={imageArry[index]} alt={`Slide ${index + 1}`} className={`slideshow-image ${fade ? "" : "fade-out"}`} />
                    </div>
                </div>
                <div className="right-image-column">
                    <div className="under-second-image">
                        <div className="textContainer">
                            <div className="leftTextDiv">
                                <Link to="/register" state={{ fromUnderConstruction: true }}>
                                    <a href="" className="kort">
                                        Inom kort kan du <br /> använda den <br /> kostnadsfria appen!
                                    </a>
                                </Link>
                                <br />
                                <p>Hemsida och produkt är under utveckling och planeras lanseras under 2026</p>
                                <p>Innan dess kommer dock appen som är helt gratis!</p>
                                <p>Bli först med att få veta när appen, produkten i sin helhet och hemsidan lanseras</p>
                            </div>
                            <div className="rightDivText">
                                <p>Och bli inbjuden till crowdfundingkampanjer, mingel (i Malmö) och andra erbjudanden genom att följa vårt nyhetsbrev</p>
                                <p>Du kan när som helst avfölja nyhetsbrevet och få din e-postadress raderad.</p>
                                <p>Läs mer om hur vi hanterar personuppgifter enligt GDPR här:</p>
                                <a href="/Integritetspolicy_tillfällig_hemsida_andreas_nystrom_ab_v2.pdf" target="_blank" rel="noopener noreferrer" className="GDPR">
                                    PDF GDPR good tomorrow
                                </a>
                            </div>
                        </div>
                        <br />
                        <div className="newsletter-box">
                            <label htmlFor="email">Nyhetsbrev:</label>

                            <input type="email" id="email" placeholder="e-postadress" value={email} onChange={(e) => setEmail(e.target.value)} />

                            <button type="button" onClick={handleRegister}>
                                Registrera
                            </button>
                        </div>
                        <video src="Good_Tommorow_Kort_Sv1.mp4" autoPlay muted loop playsInline className="gtvid">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
            <footer>
                <div className="underfooter">
                    <h3 className="fl">Kontakt: info@goodtomorrow.se</h3>
                    <h3 className="fl">
                        <a href="https://www.facebook.com/profile.php?id=61575775887972">Följ oss på facebook</a>
                    </h3>
                </div>
            </footer>
        </div>
    );
}

export default UnderConPage;
